(function ($) {
  'use strict';

  /**
   * Social Share Popups
   * ===
   */

  function windowPopup( url, width, height ) {
    // Calculate the position of the popup so
    // it’s centered on the screen.
    var pos_left  = (screen.width / 2) - (width / 2);
    var pos_top   = (screen.height / 2) - (height / 2);
    var popup_url = 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,width=' + width + ',height=' + height + ',top=' + pos_top + ',left=' + pos_left;

    window.open( url, '', popup_url );
  }

  $('.js-social-share').on('click', function () {
    windowPopup( $(this).attr('href'), 500, 300 );
    return false;
  });




  
})(jQuery);

// Social Share | Link setup

  function copyLinkToClipboard(event) {
    event.preventDefault(); // Prevent the link from navigating
  
    // Get current URL
    const pageUrl = window.location.href;

    // Use Clipboard API to copy
    navigator.clipboard.writeText(pageUrl).then(() => {
      // Show a small confirmation alert or toast notification
      alert('Link copied to clipboard!');
    }).catch(err => {
      console.error('Failed to copy link: ', err);
    });
  }
